<template>
  <div class="row mx-3 mt-4">
    <div
      class="col-sm-6 col-xs-12 mb-2 px-1 cursor"
      v-for="(data, index) in workSheetList"
      :key="index"
      @click="handleRouteChange(data)"
    >
      <Card class="module-card">
        <div class="d-flex justify-content-between">
          <div class="p-3">
            <p class="worksheet-title" :title="data.name">{{ data.name }}</p>
            <p class="reporter-label">Reporter:</p>
            <p class="reporter-title"><span v-for="(reporter,index) in data.reporters" :key="index">{{reporter.name}} </span> </p>
          </div>
          <div class="chart-area">
            <ApexChart :options="chartOptions" :series="getPercentage(data.totalNoOfTasks, data.completedTasks)" />
          </div>
        </div>
        <div class="start-date-badge my-2">
              <Badge
                v-if="data.startedDate"
                :label="`Start Date: ` + formatDate(data.startedDate)"
                class="badge-rounded badge-rounded-grey-outline ms-2"
              />
               <Badge
                v-else
                label="NOT YET STARTED"
                class="badge-neon badge-neon-warning-outline ms-2"
              />
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import Badge from "../components/BadgeComponent.vue";
import Card from "../components/CardComponent.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters, mapActions: userMapActions } = createNamespacedHelpers("User");

export default {
  name: "ModuleAssignerLayout",
  components: {
    Badge,
    Card,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 10,
          width: 10,
          type: "radialBar",
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          radialBar: {
            startAngle: 0,
            endAngle: 360,
            hollow: {
              margin: 0,
              size: "70%",
              background: "#ffffff",
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: "front",
            },
            track: {
              background: "#f3f3f3",
              strokeWidth: "80%",
              margin: 0,
            },

            dataLabels: {
              show: true,
              name: {
                offsetY: -3,
                show: true,
                color: "#888",
                fontSize: "10px",
              },
              value: {
                formatter: function (val) {
                  return val + "%";
                },
                offsetY: -3,
                color: "#000",
                fontSize: "12px",
                show: true,
              },
            },
          },
        },
        fill: {
          type: ["solid"],
          colors: ["#1da8d5"],
        },
        stroke: {
          lineCap: "round",
        },
        labels: ["Progress"],
        fontSize: "10px",
      },
    };
  },
  methods: {
    ...userMapActions({
      // getWorkSheetsByUserId: "GET_WORKSHEETS_BY_USER_ID",
      getWorkSheetsByUserId: "GET_ALL_WORKSHEET",
      addDayToWorkSheet: "ADD_DAY_TO_WORKSHEET",
      removeDayFromWorkSheet: "REMOVE_DAY_FROM_WORKSHEET",
      validateWorkSheet: "VALIDATE_WORKSHEET",
      removeTaskFromTaskList: "REMOVE_TASK_FROM_TASKLIST",
      resetCurrentWorksheet:"RESET_CURRENT_WORKSHEET",
    }),

    handleRouteChange(data) {
      this.$router.push({
        name: "WorkSheetDetailPage",
        params: {
          workSheetId: data.id,
        },
      });
    },
    getPercentage(totalTask, completedTask) {
      return [
        isNaN(Number(Math.round((completedTask / totalTask) * 100)))
          ? 0
          : Number(Math.round((completedTask / totalTask) * 100)),
      ];
    },
  },
  computed: {
    ...userMapGetters({
      workSheetList: "getAllWorkSheet",
    }),
  },
  mounted() {
    this.getWorkSheetsByUserId(this.$route.params.userId);
    this.resetCurrentWorksheet();
  },
  watch: {
    $route(to) {
      this.getWorkSheetsByUserId(to.params.userId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.cursor {
  cursor: pointer;
}

.chart-area {
  width: 150px;
  height: 100px;
  padding: 0px;
}

.worksheet-title {
  font-weight: 600;
  font-size: 14px;
  margin: 0px;
  margin-bottom: 5px;

  text-overflow: ellipsis;
    display :block;
    width: 130px;
    overflow: hidden;     
    white-space: nowrap;
}

.reporter-label {
  font-size: $font-size-sm;
  color: $badger-orange;
  font-weight: $font-weight-bold;
  margin: 0px;
}

.reporter-title {
  font-size: $font-size-sm;
  color: $light-500;
  font-weight: $font-weight-bold;
  margin: 0px;

  text-overflow: ellipsis;
    display :block;
    width: 100px;
    overflow: hidden;     
    white-space: nowrap;
}
</style>
